export const courses = {
  master_link: "https://drive.google.com/drive/folders/124p2M-boPf1FTZio6PI-bFzA0Ocaxjdm?usp=drive_link",
  courses_list: [
    {
      title: "Chapter 1",
      name: "Concepts of Economics",
      description: "Introduction to basic economic concepts and principles.",
      chapter_link: "https://drive.google.com/drive/folders/1vl2QuzKLEYCrh-jmGluDXqLaxnigDOoK?usp=drive_link",
      course_link: "https://drive.google.com/drive/folders/13ZHnXbNIhj_bhwy3p7VMrm4sHVI3ldwV?usp=drive_link",
      summary_link: "https://drive.google.com/drive/folders/1oN4ShZFYlfxmmMzKi8dX3Efc_88o6mCt?usp=drive_link",
      test_link: "chapter1"
    },
    {
      title: "Chapter 2",
      name: "Overview of the Enterprise",
      description: "Overview of the fundamental aspects of business operations at an enterprise.",
      chapter_link: "https://drive.google.com/drive/folders/1N01jXPqkL73faz2akOvvnEsB41F0sG1y?usp=drive_link",
      course_link: "https://drive.google.com/drive/folders/1JdtWCR1T2cLOhOmTdIywRX6-j4olza0Z?usp=drive_link",
      summary_link: "https://drive.google.com/drive/folders/1C-tsCNJHtyPTmZMGcBwaRIN3t2wGxEJu?usp=drive_link",
      test_link: "chapter2"
    },
    {
      title: "Chapter 3",
      name: "The Production Function",
      description: "Introduction to production management and inventory management.",
      chapter_link: "https://drive.google.com/drive/folders/17wnhmGEJP9DRWO4U6dMiDcZuB1483cfy?usp=drive_link",
      course_link: "https://drive.google.com/drive/folders/1ZXCMDg-ClbPCE9AXnIP1OCqatKL06og0?usp=drive_link",
      summary_link: "https://drive.google.com/drive/folders/1wKx7E60iAbHi2C1WkKuARtFVqahj72TN?usp=drive_link",
      test_link: "chapter3"
    },
    {
      title: "Chapter 4",
      name: "The Finance Function",
      description: "Basics of finance and financial decision-making within businesses.",
      chapter_link: "https://drive.google.com/drive/folders/1BT7tpmBGUxGvF4NgLwBaPtdnIQ7kEhAF?usp=drive_link",
      course_link: "https://drive.google.com/drive/folders/1MbTUqHvPAKfFnm3sfBdNWzBK7gruN_JP?usp=drive_link",
      summary_link: "https://drive.google.com/drive/folders/1gWG2_XXKMQYRxk0SKGuI6nZHNzAr2Chf?usp=drive_link",
      test_link: "chapter4"
    }
  ]
};